/* dzc-cosmos.js — Zodiac cosmos animator. ONE source of truth.

   Behaviour is preserved VERBATIM from the version that used to live inline in
   sections/statement-portal.liquid: 1700ms glyph cross-fade, canvas starfield,
   shooting stars, IntersectionObserver pause when off-screen, and
   prefers-reduced-motion honoured. Stars #fbf7ec; glyph colour/shadow are CSS.

   Two things are NEW, both required by the header nav:

   1. window.DZC_COSMOS.mount(scope) — the nav destroys and rebuilds its image
      plate on every hover, so new cosmos roots appear long after load. The old
      code only ever ran once at parse time.

   2. A document.contains() self-terminate guard. Without it, every plate
      re-render would leak a live rAF loop and a setInterval driving detached
      nodes; hovering the Drops list a few times would leave a dozen starfields
      animating into nothing. Each instance now checks it is still in the
      document and tears itself down if not.

   Idempotent: safe to load twice (the header and the statement portal both
   reference it) and safe to mount the same root twice.

   Backslash-free on purpose - see the handoff traps. */
(function () {
  'use strict';
  if (window.DZC_COSMOS) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCosmos(root) {
    if (!root || root.dataset.dzsCosmosOn) return;
    root.dataset.dzsCosmosOn = '1';

    var glyphs = Array.prototype.slice.call(root.querySelectorAll('[data-dzs-glyph]'));
    var gi = 0;
    var giv = null;
    var io = null;
    var rt = null;

    /* Self-terminate once the node is gone (the nav re-renders its plate on
       every hover). Everything below routes its teardown through here. */
    function dead() { return !document.contains(root); }
    function destroy() {
      if (giv) { clearInterval(giv); giv = null; }
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (io) { io.disconnect(); io = null; }
      if (rt) { clearTimeout(rt); rt = null; }
      running = false;
      window.removeEventListener('resize', onResize);
    }

    if (glyphs.length > 1 && !reduce) {
      giv = setInterval(function () {
        if (dead()) { destroy(); return; }
        glyphs[gi].classList.remove('is-on');
        gi = (gi + 1) % glyphs.length;
        glyphs[gi].classList.add('is-on');
      }, 1700);
    }

    var canvas = root.querySelector('[data-dzs-sky]');
    if (!canvas || !canvas.getContext) return;
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var stars = [], shoots = [], running = false, raf = null, last = 0, sinceShoot = 0;

    function resize() {
      var r = canvas.getBoundingClientRect();
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      buildStars();
    }
    function buildStars() {
      var n = Math.round(W * H / 2600);
      if (n < 45) n = 45; if (n > 150) n = 150;
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.2 + 0.3, p: Math.random() * 6.283, s: Math.random() * 1.5 + 0.4 });
      }
    }
    function spawnShoot() {
      var fromLeft = Math.random() < 0.5;
      shoots.push({ x: fromLeft ? -20 : W + 20, y: Math.random() * H * 0.55, vx: (fromLeft ? 1 : -1) * (Math.random() * 140 + 200), vy: Math.random() * 70 + 45, life: 0, max: Math.random() * 0.5 + 0.55 });
    }
    function drawStars(alphaScale) {
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        var a = 0.3 + 0.55 * (0.5 + 0.5 * Math.sin(st.p));
        ctx.globalAlpha = a * alphaScale;
        ctx.fillStyle = '#fbf7ec';
        ctx.beginPath(); ctx.arc(st.x, st.y, st.r, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    function frame(t) {
      if (dead()) { destroy(); return; }
      if (!last) last = t;
      var dt = Math.min(0.05, (t - last) / 1000); last = t;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < stars.length; i++) { stars[i].p += dt * stars[i].s; }
      drawStars(1);
      sinceShoot += dt;
      if (sinceShoot > 2.4 && Math.random() < 0.025) { spawnShoot(); sinceShoot = 0; }
      for (var j = shoots.length - 1; j >= 0; j--) {
        var sh = shoots[j];
        sh.life += dt; sh.x += sh.vx * dt; sh.y += sh.vy * dt;
        var k = 1 - (sh.life / sh.max); if (k < 0) k = 0;
        var sp = Math.sqrt(sh.vx * sh.vx + sh.vy * sh.vy);
        var ux = sh.vx / sp, uy = sh.vy / sp;
        var len = sp * 0.16;
        var grad = ctx.createLinearGradient(sh.x, sh.y, sh.x - ux * len, sh.y - uy * len);
        grad.addColorStop(0, 'rgba(255,250,235,' + (0.9 * k) + ')');
        grad.addColorStop(1, 'rgba(255,250,235,0)');
        ctx.strokeStyle = grad; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(sh.x, sh.y); ctx.lineTo(sh.x - ux * len, sh.y - uy * len); ctx.stroke();
        if (sh.life >= sh.max || sh.x < -60 || sh.x > W + 60 || sh.y > H + 60) { shoots.splice(j, 1); }
      }
      raf = requestAnimationFrame(frame);
    }
    function start() { if (running || reduce) return; running = true; last = 0; raf = requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = null; ctx.clearRect(0, 0, W, H); drawStars(0.7); }
    function onResize() {
      if (dead()) { destroy(); return; }
      clearTimeout(rt);
      rt = setTimeout(function () { if (dead()) { destroy(); return; } resize(); if (!running) drawStars(0.7); }, 150);
    }

    resize();
    drawStars(0.7);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { start(); } else { stop(); } }
      }, { threshold: 0.05 });
      io.observe(canvas);
    } else { start(); }
    window.addEventListener('resize', onResize);
  }

  function mount(scope) {
    var r = (scope || document).querySelectorAll('[data-dzs-cosmos]');
    for (var i = 0; i < r.length; i++) initCosmos(r[i]);
  }

  window.DZC_COSMOS = { mount: mount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }
})();
